import { useEffect, useRef, useState } from "react";
import { ArrowUpRight } from "lucide-react";

import altingunes from "../assets/markalar/altingunes.webp";
import kusakli from "../assets/markalar/kusakli.webp";
import sarayjant from "../assets/markalar/sarayjant.png";
import adavipseker from "../assets/markalar/adavipseker.webp";
import oyaarsay from "../assets/markalar/oyaarsay.webp";
import drgulcan from "../assets/markalar/drgulcan.webp";
import yilgun from "../assets/markalar/yilgun.webp";
import altincekic from "../assets/markalar/altincekic.webp";
import avityapi from "../assets/markalar/avityapi.webp";
import did from "../assets/markalar/did.webp";
import fullgarage from "../assets/markalar/fullgarage.webp";
import yagmur from "../assets/markalar/yagmur.webp";
import guzellik from "../assets/markalar/guzellik.png";
import emlak from "../assets/markalar/emlak.png";
import binnaz from "../assets/markalar/binnaztasarim.png";
import otonom from "../assets/markalar/otonom.png";
import hulyagulec from "../assets/markalar/hulyagulec.png";
import rzm from "../assets/markalar/rzmsigorta.png";
import bone from "../assets/markalar/bone.png";

const css = `
@import url('https://fonts.googleapis.com/css2?family=Unbounded:wght@500;700&family=Manrope:wght@400;500;700&display=swap');

.rf{
  --fg:oklch(0.97 0.01 270); --mute:oklch(0.72 0.03 270); --line:oklch(1 0 0 / .1);
  --a1:oklch(0.62 0.26 265); --a2:oklch(0.82 0.14 210); --a3:oklch(0.72 0.22 330);
  width:100%; max-width:1280px; margin:0 auto; font-family:'Manrope',system-ui,sans-serif; color:var(--fg);
}
.rf *{ box-sizing:border-box; }
.rf-grid{ display:grid; grid-template-columns:repeat(auto-fill,minmax(min(100%,340px),1fr)); gap:22px; }

.rf-wrap{ perspective:1100px; opacity:0; transform:translateY(40px); filter:blur(6px);
  transition:opacity .8s, transform .8s cubic-bezier(.16,1,.3,1), filter .8s; }
.rf-wrap.on{ opacity:1; transform:none; filter:none; }

.rf-card{ position:relative; display:flex; flex-direction:column; height:100%; text-decoration:none; color:inherit; text-align:left;
  border-radius:30px; border:1px solid var(--line); overflow:hidden;
  background:linear-gradient(160deg,oklch(1 0 0 / .08),oklch(1 0 0 / .02)); backdrop-filter:blur(18px);
  transform:rotateX(calc(var(--ry,0) * -5deg)) rotateY(calc(var(--rx,0) * 6deg));
  transition:transform .35s cubic-bezier(.2,.8,.2,1), border-color .3s, box-shadow .4s; }
.rf-card.link{ cursor:pointer; }
.rf-card::before{ content:""; position:absolute; inset:0; z-index:2; pointer-events:none; opacity:0; transition:opacity .3s;
  background:radial-gradient(340px circle at var(--x,50%) var(--y,50%), oklch(0.62 0.26 265 / .25), transparent 65%); }
.rf-card:hover{ border-color:oklch(0.62 0.26 265 / .55); box-shadow:0 30px 60px -30px oklch(0.62 0.26 265 / .6); }
.rf-card:hover::before{ opacity:1; }

.rf-img{ position:relative; height:200px; display:grid; place-items:center; padding:34px; overflow:hidden;
  background:radial-gradient(circle at 50% 120%, oklch(1 0 0 / .07), transparent 70%); }
.rf-img img{ position:relative; z-index:1; max-width:100%; max-height:100%; object-fit:contain;
  transition:transform .7s cubic-bezier(.16,1,.3,1), filter .5s; filter:saturate(.85); }
.rf-card:hover .rf-img img{ transform:scale(1.1) translateY(-4px); filter:saturate(1.1); }

.rf-tag{ position:absolute; left:20px; bottom:16px; z-index:3; padding:6px 12px; border-radius:99px; font-size:.75rem; font-weight:700;
  background:oklch(0.14 0.025 270 / .6); border:1px solid var(--line); backdrop-filter:blur(10px); color:var(--mute); }

.rf-go{ position:absolute; top:18px; right:18px; z-index:3; width:44px; height:44px; border-radius:50%; display:grid; place-items:center;
  background:oklch(1 0 0 / .08); border:1px solid var(--line); transform:scale(.7) rotate(-45deg); opacity:0;
  transition:transform .5s cubic-bezier(.16,1.3,.3,1), opacity .3s, background .3s; }
.rf-card:hover .rf-go{ transform:none; opacity:1; background:linear-gradient(135deg,var(--a1),var(--a3)); border-color:transparent; }

.rf-body{ position:relative; z-index:3; flex:1; display:flex; flex-direction:column; padding:24px 26px 26px; border-top:1px solid var(--line); }
.rf-body h4{ font:700 1.2rem/1.2 'Unbounded',sans-serif; letter-spacing:-0.04em; margin:0 0 12px; }
.rf-body p{ margin:0; color:var(--mute); font-size:.93rem; line-height:1.6; display:-webkit-box; -webkit-line-clamp:3; -webkit-box-orient:vertical; overflow:hidden; }
.rf-line{ margin-top:auto; padding-top:20px; }
.rf-line i{ display:block; height:2px; width:0; border-radius:2px; background:linear-gradient(90deg,var(--a2),var(--a1),var(--a3)); transition:width .7s cubic-bezier(.16,1,.3,1); }
.rf-card:hover .rf-line i{ width:100%; }

.rf :focus-visible{ outline:2px solid var(--a2); outline-offset:3px; border-radius:30px; }
@media (prefers-reduced-motion:reduce){
  .rf-wrap{ opacity:1; transform:none; filter:none; transition:none; } .rf-card{ transform:none !important; transition:none; }
}
`;

function Card({ item, index }) {
  const wrapRef = useRef(null);
  const [on, setOn] = useState(false);

  useEffect(() => {
    const el = wrapRef.current;
    if (!el) return;
    const io = new IntersectionObserver(([e]) => { if (e.isIntersecting) { setOn(true); io.disconnect(); } }, { threshold: 0.12 });
    io.observe(el);
    return () => io.disconnect();
  }, []);

  const move = (e) => {
    const el = e.currentTarget, r = el.getBoundingClientRect();
    el.style.setProperty("--x", e.clientX - r.left + "px");
    el.style.setProperty("--y", e.clientY - r.top + "px");
    el.style.setProperty("--rx", ((e.clientX - r.left) / r.width - 0.5).toFixed(2));
    el.style.setProperty("--ry", ((e.clientY - r.top) / r.height - 0.5).toFixed(2));
  };
  const leave = (e) => { e.currentTarget.style.setProperty("--rx", 0); e.currentTarget.style.setProperty("--ry", 0); };

  const hasLink = Boolean(item.link);
  const Tag = hasLink ? "a" : "div";
  const linkProps = hasLink ? { href: item.link, target: "_blank", rel: "noopener noreferrer", "aria-label": `${item.title} sitesini aç` } : {};

  return (
    <div ref={wrapRef} className={`rf-wrap ${on ? "on" : ""} `} style={{ transitionDelay: `${(index % 3) * 0.1}s` }}>
      <Tag className={`rf-card ${hasLink ? "link" : ""}`} onMouseMove={move} onMouseLeave={leave} {...linkProps}>
        <div className="rf-img">
          <img src={item.logo} alt={item.title} loading="lazy" />
          <span className="rf-tag">{item.tag}</span>
          {hasLink && <span className="rf-go"><ArrowUpRight size={20} /></span>}
        </div>
        <div className="rf-body">
          <h4>{item.title}</h4>
          <p>{item.text}</p>
          <div className="rf-line"><i /></div>
        </div>
      </Tag>
    </div>
  );
}

export default function ReferencesGrid({ limit }) {
  const items = [
    { title: "Astronot Bone", text: "Toptan Bone Satışı için Web Tasarımı", logo: bone, tag: "Web Design", link: "https://toptanastronotbone.com" },
    { title: "RZM Sigorta", text: "RZM Sigorta Güvenilir Sigorta Acenteliği Hizmeti için Web Tasarımı", logo: rzm, tag: "Web Design", link: "https://rzmsigorta.com" },
    { title: "Psikoterapist Hülya Güleç", text: "Lisanslı Psikolog Hülya Güleç için Web Tasarımı", logo: hulyagulec, tag: "Web Design", link: "https://psychotherapie-gulec.com/en" },
    { title: "Full Garage", text: "Araç Estetiği & Koruma Hizmetleri dijital kimlik çalışması.", logo: fullgarage, tag: "Web Design", link: "https://fethiyefullgaraj.com/" },
    { title: "Altın Güneş", text: "Lüks organizasyon ve kır düğünü konsepti için görsel odaklı web arayüzü.", logo: altingunes, tag: "Web Design", link: "https://altingunes.com" },
    { title: "Saray Jant", text: "CNC jant yenileme ve TPMS teknolojileri için geliştirilmiş servis portalı.", logo: sarayjant, tag: "Web Design", link: "https://sarayjant.com" },
    { title: "Visual Showcase & Portfolio", text: "Tasarımcılar için estetik ve performansın birleştiği modern web arayüzü çalışması.", logo: binnaz, tag: "Web Design", link: "https://www.binnazky.com" },
    { title: "Estetik ve Rezervasyon Template", text: "Güzellik merkezleri için optimize edilmiş, minimalist proje.", logo: guzellik, tag: "Web Design", link: "https://www.diajans.xyz" },
    { title: "Emlak Dünyası İlan", text: "Dijital tasarım çalışmalarının bulunduğu portfolyo web arayüzü.", logo: emlak, tag: "Web Design", link: "https://estate-red-psi.vercel.app/" },
    { title: "Dijital Tasarımcı Portfolio", text: "Dijital tasarım çalışmalarının bulunduğu portfolyo web arayüzü.", logo: yagmur, tag: "Web Design", link: "https://yagmurkalfa.vercel.app" },
    { title: "Web Otomasyon", text: "Emailden veri çekerek işlerinizi daha kolay yönetmenizi sağlayabilen bir otonom çalışması", logo: otonom, tag: "Web Autonomous", link: "" },
    { title: "Kuşaklı Ticaret", text: "Ürün çeşitliliğini teknik detaylarla buluşturan dinamik dijital katalog.", logo: kusakli, tag: "Web Design" },
    { title: "Adavip Şeker", text: "Gıda ambalaj sektöründe kurumsal kimlik odaklı ürün sergileme modülü.", logo: adavipseker, tag: "Web Design", link: "https://adavipseker.com.tr/" },
    { title: "Yilgun Turizm", text: "Hac ve Umre organizasyonları için kullanıcı dostu tur yönetim arayüzü.", logo: yilgun, tag: "Web Design", link: "http://yilgun.com/" },
    { title: "Oya Arsay İç Mimarlık", text: "İç mimari ve dekorasyonda estetik algıyı ön plana çıkaran portföy vitrini.", logo: oyaarsay, tag: "Web Design", link: "https://oyaarsay.com/" },
    { title: "Altın Çekiç", text: "Otomobil onarımını sanatla buluşturan vizyoner platform.", logo: altincekic, tag: "Web Design", link: "https://www.altincekic.com.tr/" },
    { title: "Dr. Gülcan", text: "Dermatoloji ve kozmetoloji alanında tıbbi güvenle estetiği buluşturan klinik.", logo: drgulcan, tag: "Web Design", link: "https://www.drgulcanyuksekal.com/" },
    { title: "Avit Yapı", text: "Modern konut ve inşaat projeleri için yüksek çözünürlüklü dijital katalog.", logo: avityapi, tag: "Web Design", link: "https://avityapi.com/" },
    { title: "Did Game", text: "Oyun geliştirme sektöründe yenilikçi projeler sunan dinamik web sitesi.", logo: did, tag: "Web Design", link: "https://didgame.vercel.app/" },
  ];

  const visibleItems = limit ? items.slice(0, limit) : items;

  return (
    <div className="rf">
      <style>{css}</style>
      <div className="rf-grid">
        {visibleItems.map((item, i) => <Card key={item.title} item={item} index={i} />)}
      </div>
    </div>
  );
}